import { memo } from "react"

export const InvoiceIcon = memo(() => (
  <svg
    width="20px"
    height="30px"
    viewBox="0 0 31 40"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Attachment</title>
    <defs>
      <path
        d="M0,2.0000011 L0,34.6588484 C1.3527075e-16,35.7634179 0.8954305,36.6588484 2,36.6588484 L25.0803337,36.6588484 C26.1848206,36.6586368 27.0802168,35.7633353 27.0805453,34.6588484 L27.083192,9.64220897 L27.083192,9.64220897 L17.1604345,0.108765735 L2.01435491,5.26171423e-05 C0.909813864,-0.00787538167 0.00797951534,0.881105141 5.15165359e-05,1.98564619 C1.71722892e-05,1.99043108 -6.6671981e-16,1.99521608 0,2.0000011 Z"
        id="path-1"
      ></path>
    </defs>
    <g id="Employer" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Employer_invoices" transform="translate(-425.000000, -251.000000)">
        <g id="Section" transform="translate(426.000000, 198.000000)">
          <g id="Attachment" transform="translate(0.000000, 54.000000)">
            <g id="Shape" transform="translate(0.719666, 0.014406)">
              <mask id="mask-2" fill="white">
                <use xlinkHref="#path-1"></use>
              </mask>
              <use
                id="Mask"
                stroke="#EFF1F4"
                strokeWidth="2"
                fill="#FFFFFF"
                fillRule="nonzero"
                xlinkHref="#path-1"
              ></use>
              <path
                d="M29.2062161,11.6422087 L18.8667891,11.6422087 C17.3722214,11.6422087 16.1609488,10.43026 16.1609488,8.93569227 L16.1609488,-0.891234265 L29.2062161,11.6422087 Z"
                stroke="#EFF1F4"
                strokeWidth="2"
                fill="#FFFFFF"
                fillRule="nonzero"
                mask="url(#mask-2)"
              ></path>
            </g>
            <rect id="Rectangle" fill="#EC3B7E" x="4" y="22" width="21" height="12" rx="2"></rect>
            <text
              id="PDF"
              fontFamily="InterUI-ExtraBold, Inter UI"
              fontSize="9"
              fontWeight="600"
              fill="#FFFFFF"
            >
              <tspan x="6.0787845" y="31.4285714">
                PDF
              </tspan>
            </text>
          </g>
        </g>
      </g>
    </g>
  </svg>
))

InvoiceIcon.displayName = "InvoiceIcon"
